import { Badge } from '@/components/ui/badge';
import type { OrgRole } from '../types';

/**
 * Organization-role badge (design §10). Semantic mapping inside the existing
 * token set — `owner` (the authority role) takes the primary fill, `admin` the
 * secondary, `member` the outline. No new colors (B1).
 *
 * These badges are informational only: they never gate an action (§14.5 — the
 * client must not infer permissions from `orgRole`).
 */
const BADGE_VARIANTS: Record<OrgRole, 'default' | 'secondary' | 'outline'> = {
  owner: 'default',
  admin: 'secondary',
  member: 'outline',
};

export function OrgRoleBadge({ role }: { role: OrgRole | string | undefined }) {
  const variant = BADGE_VARIANTS[(role ?? 'member') as OrgRole] ?? 'outline';
  const label = role ?? 'member';
  return <Badge variant={variant}>{label}</Badge>;
}
